export default "__VITE_ASSET__BGHWPXqv__"